var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"uk-icon":_vm.currentIcon},on:{"click":function($event){$event.stopPropagation();return _vm.newValue.apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }